var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),attrs:{"element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(255,255,255,0)"}},[_c('div',{ref:_vm.id,style:(_vm.styleChartName)})])
}
var staticRenderFns = []

export { render, staticRenderFns }